import React, { useCallback, useEffect, useState } from 'react'
import { useAdditionalSales } from '../../hooks/AdditionalSalesHooks'
import AdditionalSalesSecretButton from './AdditionalSalesSecretButton'
import AdditionalSalesDetail from './AdditionalSalesDetail'
import AdditionalSalesHome from './AdditionalSalesHome'
import AdditionalSalesThemeSplashScreen from './AdditionalSalesThemeSplashScreen'
import './AdditionalSalesView.css'
import { ADDITIONAL_SALES_DATA_REFRESH_INTERVAL } from '../../utils/constantes'
import { useAdditionalSalesAssetPreload } from '../../hooks/PreloadedImage'

const AdditionalSalesView = ({ changeView }) => {
  const { additionalSales, refresh } = useAdditionalSales()
  const { detailBackgroundSrc, homeBackgroundSrc, homeLoaded } = useAdditionalSalesAssetPreload()
  const [detailOpen, setDetailOpen] = useState(false)
  const [homePainted, setHomePainted] = useState(false)
  const [selectedThemeId, setSelectedThemeId] = useState(null)
  const [detailTimerResetKey, setDetailTimerResetKey] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      refresh()
    }, ADDITIONAL_SALES_DATA_REFRESH_INTERVAL)

    return () => clearInterval(interval)
  }, [refresh])

  const openTheme = useCallback((themeId) => {
    setSelectedThemeId(themeId)
  }, [])

  const openThemeFromDetail = useCallback((themeId) => {
    setDetailTimerResetKey((key) => key + 1)
    setSelectedThemeId(themeId)
  }, [])

  const closeTheme = useCallback(() => {
    setSelectedThemeId(null)
  }, [])

  const openDetail = useCallback(() => {
    setDetailOpen(true)
    setDetailTimerResetKey((key) => key + 1)
  }, [])

  const closeDetail = useCallback(() => {
    setDetailOpen(false)
  }, [])

  const markHomePainted = useCallback(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setHomePainted(true)
      })
    })
  }, [])

  return (
    <>
      {homeLoaded && (
        <AdditionalSalesHome
          onBackgroundReady={markHomePainted}
          onThemeClick={openTheme}
          themesAvailability={additionalSales?.themesAvailability ?? null}
          backgroundSrc={homeBackgroundSrc}
        />
      )}

      {homePainted && (
        <>
          <AdditionalSalesDetail
            additionalSales={additionalSales}
            backgroundSrc={detailBackgroundSrc}
            isOpen={detailOpen}
            onClose={closeDetail}
            onThemeClick={openThemeFromDetail}
            themeSplashOpen={Boolean(selectedThemeId)}
            resetTimerKey={detailTimerResetKey}
          />

          <AdditionalSalesSecretButton
            style={{ left: 0, right: 'auto', zIndex: 20 }}
            onClick={detailOpen ? closeDetail : openDetail}
          />
          {!detailOpen && (
            <AdditionalSalesSecretButton style={{ zIndex: 20 }} onClick={changeView} />
          )}

          <AdditionalSalesThemeSplashScreen themeId={selectedThemeId} onClose={closeTheme} />
        </>
      )}

      {!homePainted && (
        <div className="additionalSalesLoader">
          <div className="additionalSalesSpinner" />
        </div>
      )}
    </>
  )
}

export default AdditionalSalesView
